<template>
    <div>
      <div style="margin-bottom:1rem;">
        <div style="padding-bottom:0.35rem;">
          <span class="us_block_title">超速记录</span>
          <span style="font-size: 0.9rem;color: #9e9e9e;">(今天)</span>
          <span class="us_block_more_text" @click="goList(2)">
            <span>更多</span><i class="fa fa-angle-right" aria-hidden="true"></i>
          </span>
        </div>
        <div v-if="loading" style="margin-top:1rem;">
          <LoadingText />
        </div>
        <div :style="{background:(abnormalList.length > 0?'#eee':'#fff')}" v-else>
            <div v-if="abnormalList.length > 0">
              <div v-for="(item,index) in abnormalList" :key="index">
                <NotifyCard :item="item" flat />
              </div>
            </div>
            <div v-if="abnormalList.length === 0" style="text-align:center;padding:1rem 0;color:#9e9e9e;font-size:0.8rem;">
                今天暂无记录
            </div>
        </div>

      </div>

      <div style="padding-bottom:0.35rem;">
        <span class="us_block_title">正常记录</span>
        <span style="font-size: 0.9rem;color: #9e9e9e;">(今天)</span>
        <span class="us_block_more_text" @click="goList(1)">
          <span>更多</span><i class="fa fa-angle-right" aria-hidden="true"></i>
        </span>
      </div>
      <div v-if="loading" style="margin-top:1rem;">
        <LoadingText />
      </div>
      <div :style="{background:(normalList.length > 0?'#eee':'#fff')}" v-else>
          <div v-if="normalList.length > 0">
            <div v-for="(item,index) in normalList" :key="index">
              <NotifyCard :item="item" flat />
            </div>
          </div>
          <div v-if="normalList.length === 0" style="text-align:center;padding:1rem 0;color:#9e9e9e;font-size:0.8rem;">
              今天暂无记录
          </div>
      </div>
    </div>
</template>

<script>
import LoadingText from '../../components/LoadingText'
import NotifyCard from '../../Biz/Notify/components/NotifyCard.vue'
export default {
  components: { LoadingText, NotifyCard },
  props: {
  },
  data() {
    return {
      loading: true,
      normalList: [],
      abnormalList: [],
      pageIndex: 1,
      pageCount: 3,
      hasMore: true,
      timeout: null
    }
  },
  computed: {
  },
  mounted() {
    this.init()
  },
  created() {
  },
  destroyed() {
    var that = this
    if (that.timeout) {
      window.clearTimeout(that.timeout)
    }
  },
  activated() {
    this.refreshCamImageTask();
  },
  deactivated() {
    var that = this
    if (that.timeout) {
      window.clearTimeout(that.timeout)
    }
  },
  methods: {
    async init() {
      var that = this
      await that.getNormalCamImageList()
      await that.getAbnormalCamImageList()
      that.loading = false

      setTimeout(() => {
        that.refreshCamImageTask()
      }, 1000 * 10)
    },
    goBack() {
      this.$router.goBack()
    },
    // 格式化时间显示
    getMsgTimeFormat(time) {
      var that = this
      var mt = that.$moment(time)
      var tv = mt.format('YYYY-MM-DD')
      var now = that.$moment(new Date()).format('YYYY-MM-DD')
      if (tv < now) {
        var zt = that.$moment(new Date()).add(-1, 'days').format('YYYY-MM-DD')
        if (zt === tv) {
          return mt.format('昨天 HH:mm')
        }
        return mt.format('YYYY-MM-DD HH:mm')
      }
      return mt.format('今天 HH:mm')
    },
    goList(type) {
      this.$router.goPage({
        path: '/DeviceNotifyListV2',
        query: { type: type }
      })
    },
    // 时间格式化
    getDuraStr(sec) {
      var strDura = ''
      var dura = 0
      if (sec >= 86400) {
        dura = Number.parseInt(sec / 60 / 60 / 24);
        strDura = dura + ' 天';
      } else if (sec >= 3600) {
        dura = Number.parseInt(sec / 60 / 60);
        strDura = dura + ' 小时';
      } else if (sec >= 60) {
        dura = Number.parseInt(sec / 60);
        strDura = dura + ' 分钟';
      } else {
        strDura = dura + ' 秒';
      }
      return strDura
    },
    async getNormalCamImageList() {
      var that = this
      var res = await that.$api.bz.getCamImageByCurDate({ peccancy_type: '正常' })
      // console.log('getCamImageByCurDate.res', res)
      if (!res.success) {
        return
      }
      var data = res.data
      that.normalList = data.list
    },
    async getAbnormalCamImageList() {
      var that = this
      var res = await that.$api.bz.getCamImageByCurDate({ peccancy_type: '超速' })
      // console.log('getCamImageByCurDate.res', res)
      if (!res.success) {
        return
      }
      var data = res.data
      that.abnormalList = data.list
    },
    async getRefreshNormal() {
      var that = this
      var cam_image_id = 0
      var last_time = ''
      if (that.normalList && that.normalList.length > 0) {
        cam_image_id = that.normalList[0].CAM_IMAGE_ID
        last_time = that.normalList[0].CAPTURE_TIME
      }
      var res = await that.$api.bz.getRefreshCamImage({ peccancy_type: '正常', cam_image_id: cam_image_id, last_time: last_time })
      // console.log('getRefreshCamImage.res', res)
      if (!res.success) {
        return
      }
      var data = res.data
      if (data.count) {
        var arrList = data.list
        for (var i = 0; i < arrList.length; i++) {
          const item = arrList[i]
          that.normalList.unshift(item)
          if (that.normalList.length > 3) {
            that.normalList.pop()
          }
        }
      }
      // console.log(that.normalList)
    },
    async getRefreshAbnormal() {
      var that = this
      var cam_image_id = 0
      var last_time = ''
      if (that.abnormalList && that.abnormalList.length > 0) {
        cam_image_id = that.abnormalList[0].CAM_IMAGE_ID
        last_time = that.abnormalList[0].CAPTURE_TIME
      }
      var res = await that.$api.bz.getRefreshCamImage({ peccancy_type: '超速', cam_image_id: cam_image_id, last_time: last_time })
      // console.log('getRefreshCamImage.res', res)
      if (!res.success) {
        return
      }
      var data = res.data
      if (data.count) {
        var arrList = data.list
        for (var i = 0; i < arrList.length; i++) {
          const item = arrList[i]
          that.abnormalList.unshift(item)
          if (that.abnormalList.length > 3) {
            that.abnormalList.pop()
          }
        }
      }
    },
    async refreshCamImageTask() {
      var that = this
      if (that.timeout) {
        window.clearTimeout(that.timeout)
      }

      await that.getRefreshNormal()
      await that.getRefreshAbnormal()
      that.timeout = setTimeout(that.refreshCamImageTask, 10 * 1000)
    }
  }
}
</script>

<style scoped>
.us-v-badge >>> .v-badge__badge{
  height: 5px !important;
  width: 5px !important;
}

.us-list-item >>> .v-list-item__icon{
  min-width: 0.9rem;
}

.us_block_title{
  font-weight:bold;
  font-size:1.05rem;
  color: rgba(33,33,33,0.9);
}
.us_block_more_text{
  font-size:0.8rem;
  padding-top:0.3rem;
  padding-right:0.4rem;
  float:right;
  color:#9e9e9e;
  cursor: pointer;
}
.us_block_more_text span{
  font-size:0.8rem;
}
.us_block_more_text i{
  margin-left:0.4rem;
}

</style>

